import Slider from 'react-slick'
import { MouseEvent, useState } from 'react'
import AppleIcon from '@mui/icons-material/Apple'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useMediaQuery, themeClubbi } from 'clubbi-ui'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import {
  StyledPage,
  StyledSectionOne,
  StyledSectionOneYellowBand,
  StyledSectionOneContent,
  StyledSectionOneTitle,
  StyledSectionOneText,
  StyledSectionOneCta,
  StyledSectionOneImages,
  StyledSectionOneImg,
  StyledSectionTwo,
  StyledSectionTwoHeader,
  StyledSectionTwoOrangeContent,
  StyledSectionTwoLogo,
  StyledSectionTwoTitle,
  StyledSectionTwoText,
  StyledSectionTwoCarouselWrap,
  StyledSectionTwoCarouselCardsRow,
  StyledSectionTwoCarouselCard,
  StyledSectionTwoCarouselCardImageWrap,
  StyledSectionTwoCarouselCardTitle,
  StyledSectionTwoCarouselCardSubtitle,
  StyledSectionTwoSlick,
  StyledSectionTwoCtaWrap,
  StyledSectionTwoCta,
  StyledSectionTwoPurple,
  StyledSectionTwoPurpleContent,
  StyledSectionTwoPurpleTitle,
  StyledSectionTwoPurpleText,
  StyledSectionTwoPurpleTextStrong,
  StyledSectionTwoPurpleShopTitle,
  StyledSectionTwoPurpleRight,
  StyledSectionTwoPremios,
  StyledSectionTwoPremiosLabel,
  StyledSectionTwoDisclaimer,
  StyledSectionThree,
  StyledSectionThreeTop,
  StyledSectionThreeTextContent,
  StyledSectionThreeTitle,
  StyledSectionThreeDescription,
  StyledSectionThreeButtons,
  StyledSectionThreeButton,
  StyledSectionThreeNotice,
  StyledSectionThreeNoticeTitle,
  StyledSectionThreeNoticeText,
  StyledSectionFour,
  StyledSectionFourContent,
  StyledSectionFourTitle,
  StyledSectionFourText,
  StyledSectionFourSupport,
  StyledSectionFourSupportText,
  StyledSectionFourSupportPhone,
  StyledSectionFourRight,
  StyledSectionFourAppImage,
  StyledSectionFourStoreButtons,
  StyledSectionFourStoreButton,
  StyledSectionFive,
  StyledSectionFiveContent,
  StyledSectionFiveImageWrap,
  StyledSectionFiveImage,
  StyledSectionFiveTitle,
  StyledSectionFiveText,
  StyledSectionFiveCtaRow,
  StyledSectionFiveCtaText,
  StyledSectionFiveCta,
  ButtonSpinner,
} from './styles/RedirectAbasteceShop.style'
import { URLS_ABASTECE_SHOP } from '../../common/constants'
import { useAppSelector } from '../../common/hooks'
import { redirectToAbasteceShopWithSso } from '../../common/abasteceShopSso'

const IMG_BASE = `${process.env.PUBLIC_URL || ''}/img/landingpage_abasteceshop`
const img = (name: string) => `${IMG_BASE}/${encodeURIComponent(name)}`

const SECTION_TWO_CAROUSEL = [
  {
    img: 'compras 1.png',
    title: 'Compras em um só lugar',
    subtitle: 'Oportunidades pensadas para quem compra pela plataforma.',
  },
  {
    img: 'image 52.png',
    title: 'Tecnologia para o varejo',
    subtitle: 'Acompanhe pedidos, histórico e tenha mais visão para decidir melhor.',
  },
  {
    img: 'ofertas 1.png',
    title: 'Ofertas e condições exclusivas',
    subtitle: 'Oportunidades pensadas para quem compra pela plataforma.',
  },
]

export const RedirectAbasteceShop = () => {
  const isDesktop = useMediaQuery(themeClubbi.breakpoints.up('md'))
  const merchantCode = useAppSelector((state) => state.session.merchantCode)

  type CtaId = 'sectionOne' | 'sectionTwo' | 'sectionFive'
  const [loadingCta, setLoadingCta] = useState<CtaId | null>(null)

  const handleAbasteceShopRedirectClick =
    (ctaId: CtaId) => async (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      if (loadingCta) return
      try {
        setLoadingCta(ctaId)
        await redirectToAbasteceShopWithSso(merchantCode)
      } finally {
        setLoadingCta(null)
      }
    }

  return (
    <StyledPage>
      <StyledSectionOne>
        <StyledSectionOneYellowBand aria-hidden />
        <StyledSectionOneContent>
          <StyledSectionOneTitle>A Clubbi agora é AbasteceShop!</StyledSectionOneTitle>
          <StyledSectionOneText>
            Agora, as compras passam a ser feitas pelo AbasteceShop.
          </StyledSectionOneText>
          <StyledSectionOneText>
            A mesma parceria que você já conhece, agora em uma plataforma mais moderna, prática e
            com mais benefícios.
          </StyledSectionOneText>
          <StyledSectionOneCta onClick={handleAbasteceShopRedirectClick('sectionOne')}>
            {loadingCta === 'sectionOne' ? <ButtonSpinner /> : 'Acessar agora'}
          </StyledSectionOneCta>
        </StyledSectionOneContent>
        <StyledSectionOneImages>
          <StyledSectionOneImg src={img('img-main-1400.png')} alt="AbasteceShop" />
        </StyledSectionOneImages>
      </StyledSectionOne>

      <StyledSectionTwo>
        <StyledSectionTwoHeader>
          <StyledSectionTwoOrangeContent>
            <StyledSectionTwoTitle>Sobre o AbasteceShop</StyledSectionTwoTitle>
            <StyledSectionTwoText>
              O AbasteceShop organiza suas compras em um único ambiente, trazendo mais praticidade e
              mais visão para o seu negócio.
            </StyledSectionTwoText>
            {isDesktop && (
              <StyledSectionTwoCtaWrap>
                <StyledSectionTwoCta onClick={handleAbasteceShopRedirectClick('sectionTwo')}>
                  {loadingCta === 'sectionTwo' ? <ButtonSpinner /> : 'Acessar agora'}
                </StyledSectionTwoCta>
              </StyledSectionTwoCtaWrap>
            )}
          </StyledSectionTwoOrangeContent>
          <StyledSectionTwoLogo>
            <img src={img('abastece_icon.png')} alt="AbasteceShop" />
          </StyledSectionTwoLogo>
        </StyledSectionTwoHeader>
        <StyledSectionTwoCarouselWrap>
          {isDesktop ? (
            <StyledSectionTwoCarouselCardsRow>
              {SECTION_TWO_CAROUSEL.map((item, index) => (
                <StyledSectionTwoCarouselCard key={index} $isCenter={index === 1}>
                  <StyledSectionTwoCarouselCardImageWrap $isCenter={index === 1}>
                    <img src={img(item.img)} alt={item.title} />
                  </StyledSectionTwoCarouselCardImageWrap>
                  <StyledSectionTwoCarouselCardTitle>
                    {item.title}
                  </StyledSectionTwoCarouselCardTitle>
                  <StyledSectionTwoCarouselCardSubtitle>
                    {item.subtitle}
                  </StyledSectionTwoCarouselCardSubtitle>
                </StyledSectionTwoCarouselCard>
              ))}
            </StyledSectionTwoCarouselCardsRow>
          ) : (
            <StyledSectionTwoSlick>
              <Slider
                infinite
                dots
                arrows={false}
                centerMode
                centerPadding="38px"
                slidesToShow={1}
                slidesToScroll={1}
                speed={300}
              >
                {SECTION_TWO_CAROUSEL.map((item, index) => (
                  <StyledSectionTwoCarouselCard key={index}>
                    <StyledSectionTwoCarouselCardImageWrap>
                      <img src={img(item.img)} alt={item.title} />
                    </StyledSectionTwoCarouselCardImageWrap>
                    <StyledSectionTwoCarouselCardTitle>
                      {item.title}
                    </StyledSectionTwoCarouselCardTitle>
                    <StyledSectionTwoCarouselCardSubtitle>
                      {item.subtitle}
                    </StyledSectionTwoCarouselCardSubtitle>
                  </StyledSectionTwoCarouselCard>
                ))}
              </Slider>
            </StyledSectionTwoSlick>
          )}
        </StyledSectionTwoCarouselWrap>
        {!isDesktop && (
          <StyledSectionTwoCtaWrap>
            <StyledSectionTwoCta onClick={handleAbasteceShopRedirectClick('sectionTwo')}>
              {loadingCta === 'sectionTwo' ? <ButtonSpinner /> : 'Acessar agora'}
            </StyledSectionTwoCta>
          </StyledSectionTwoCtaWrap>
        )}
        <StyledSectionTwoPurple>
          <StyledSectionTwoPurpleContent>
            <StyledSectionTwoPurpleTitle>Seu abastecimento vale mais!</StyledSectionTwoPurpleTitle>
            <StyledSectionTwoPurpleText>
              Com o Shop+ suas compras geram pontos que se transformam em vantagens reais para a sua
              loja.
            </StyledSectionTwoPurpleText>
            <StyledSectionTwoPurpleTextStrong>
              Participe de desafios com indústrias parceiras, acumule pontos* e troque por:
            </StyledSectionTwoPurpleTextStrong>
          </StyledSectionTwoPurpleContent>
          <StyledSectionTwoPurpleRight>
            <StyledSectionTwoPurpleShopTitle>Shop +</StyledSectionTwoPurpleShopTitle>
            <StyledSectionTwoPremios>
              <img src={img('desconto 2.png')} alt="Prêmios" />
              <StyledSectionTwoPremiosLabel>Prêmios exclusivos</StyledSectionTwoPremiosLabel>
            </StyledSectionTwoPremios>
          </StyledSectionTwoPurpleRight>
          <StyledSectionTwoDisclaimer>
            *Pontuação e recompensas conforme regulamento do programa disponível na plataforma.
          </StyledSectionTwoDisclaimer>
        </StyledSectionTwoPurple>
      </StyledSectionTwo>

      <StyledSectionThree>
        <StyledSectionThreeTop>
          <StyledSectionThreeTextContent>
            <StyledSectionThreeTitle>Por que a mudança?</StyledSectionThreeTitle>
            <StyledSectionThreeDescription>
              Evoluímos para oferecer uma solução mais completa, digital e eficiente para o seu
              negócio. O AbasteceShop passa a ser a nova plataforma de compras da Clubbi.
            </StyledSectionThreeDescription>
          </StyledSectionThreeTextContent>
          <StyledSectionThreeButtons>
            <StyledSectionThreeButton>Mais tecnologia</StyledSectionThreeButton>
            <StyledSectionThreeButton>Mais benefícios</StyledSectionThreeButton>
            <StyledSectionThreeButton>Mais autonomia</StyledSectionThreeButton>
          </StyledSectionThreeButtons>
        </StyledSectionThreeTop>
        <StyledSectionThreeNotice>
          <StyledSectionThreeNoticeTitle>Fique tranquilo.</StyledSectionThreeNoticeTitle>
          <StyledSectionThreeNoticeText>
            Nada muda na sua parceria com a gente. Seus dados continuam protegidos, o atendimento
            segue o mesmo e as condições também.
          </StyledSectionThreeNoticeText>
        </StyledSectionThreeNotice>
      </StyledSectionThree>

      <StyledSectionFour>
        <StyledSectionFourContent>
          <StyledSectionFourTitle>Acesse também pelo app</StyledSectionFourTitle>
          <StyledSectionFourText>
            O AbasteceShop também está disponível em versão mobile.
          </StyledSectionFourText>
        </StyledSectionFourContent>
        <StyledSectionFourRight>
          <StyledSectionFourAppImage src={img('app 1.png')} alt="App AbasteceShop" />
          <StyledSectionFourStoreButtons>
            <StyledSectionFourStoreButton href={URLS_ABASTECE_SHOP.APP_STORE_ABASTECE_SHOP}>
              <AppleIcon fontSize="small" />
              App Store
            </StyledSectionFourStoreButton>
            <StyledSectionFourStoreButton href={URLS_ABASTECE_SHOP.PLAY_STORE_ABASTECE_SHOP}>
              <PlayArrowIcon fontSize="small" />
              Play Store
            </StyledSectionFourStoreButton>
          </StyledSectionFourStoreButtons>
        </StyledSectionFourRight>
        <StyledSectionFourSupport>
          <StyledSectionFourSupportText>
            Não conseguiu acessar? Entre em contato com nosso suporte
          </StyledSectionFourSupportText>
          <StyledSectionFourSupportPhone
            href="https://wa.me/552136093614"
            target="_blank"
            rel="noreferrer"
          >
            <WhatsAppIcon />
            (21) 3609-3614
          </StyledSectionFourSupportPhone>
        </StyledSectionFourSupport>
      </StyledSectionFour>

      <StyledSectionFive>
        <StyledSectionFiveImageWrap>
          <StyledSectionFiveImage src={img('Group 1461.png')} alt="Agora é pelo AbasteceShop" />
        </StyledSectionFiveImageWrap>
        <StyledSectionFiveContent>
          <StyledSectionFiveTitle>Agora é pelo AbasteceShop</StyledSectionFiveTitle>
          <StyledSectionFiveText>
            O AbasteceShop já está pronto para facilitar suas compras e trazer mais retorno para sua
            loja.
          </StyledSectionFiveText>
          <StyledSectionFiveCtaRow>
            <StyledSectionFiveCtaText>
              Acesse a plataforma e faça seus próximos pedidos por lá.
            </StyledSectionFiveCtaText>
            <StyledSectionFiveCta onClick={handleAbasteceShopRedirectClick('sectionFive')}>
              {loadingCta === 'sectionFive' ? <ButtonSpinner /> : 'Acesse agora'}
            </StyledSectionFiveCta>
          </StyledSectionFiveCtaRow>
        </StyledSectionFiveContent>
      </StyledSectionFive>
    </StyledPage>
  )
}
